import { useState } from 'react';

const SegmentedControl = ({ segments, defaultSelected = 0, onChange }) => {
  const [selectedIndex, setSelectedIndex] = useState(defaultSelected);

  const handleSegmentClick = (index) => {
    setSelectedIndex(index);
    if (onChange) {
      onChange(index);
    }
  };

  return (
    <div className="inline-flex bg-[#F1F1F1] rounded-md p-1 w-fit">
      {segments.map((segment, index) => (
        <button
          key={index}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 ease-in-out
            ${selectedIndex === index 
              ? 'bg-[#FFF] text-gray-900 shadow-sm' 
              : 'bg-transparent text-gray-300 hover:bg-[#FFF]'}`}
          onClick={() => handleSegmentClick(index)}
        >
          {segment}
        </button>
      ))}
    </div>
  );
};

export default SegmentedControl;